import {useEffect, useState} from "react";
import {Button} from "primereact/button";
import {FileUpload} from "primereact/fileupload";
import axios from "axios";
import {Dialog} from "primereact/dialog";

export default function ReportSingleFileUploader({
	dialogFileName,
	uploadedFile,
	setUploadedFile,
	selectedRow,
	combinedURL,
	dialogHearder,
	isFilesDialogVisible,
	setIsFilesDialogVisible,
	toast,
	fetchData,
}) {
	const [newFile, setNewFile] = useState(false);

	const handleFileSelect = event => {
		setUploadedFile(event.files[0]);
		setNewFile(true);
	};

	const saveData = async () => {
		const formData = new FormData();

		formData.append("file", uploadedFile);
		formData.append("contract_instance", selectedRow.id);
		formData.append("template", selectedRow.templateID);

		try {
			const response = await axios.post(`${combinedURL}`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			toast.current?.show({
				severity: "success",
				summary: "Success",
				detail: "The file has successfully uploaded",
				life: 3000,
			});
			setIsFilesDialogVisible(false);
			fetchData();
		} catch (error) {
			console.error("Error saving data:", error);
			toast.current?.show({
				severity: "danger",
				summary: "Error",
				detail: "There was a problem while uploading file",
				life: 3000,
			});
			fetchData();
		}
	};

	const dialogFooter = (
		<div>
			<Button
				label="Cancel"
				icon="pi pi-times"
				severity="secondary"
				rounded
				className="mx-1"
				onClick={() => {
					setIsFilesDialogVisible(false);
					setNewFile(false);
					setUploadedFile(null);
				}}
			/>
			<Button
				label="Save"
				icon="pi pi-check"
				severity="primary"
				rounded
				className="mx-1"
				onClick={saveData}
			/>
		</div>
	);

	return (
		<Dialog
			visible={isFilesDialogVisible}
			onHide={() => setIsFilesDialogVisible(false)}
			header={dialogHearder}
			modal
			footer={dialogFooter}
			className="col-lg-8 col-11 mx-auto">
			<div>
				{newFile
					? null
					: uploadedFile && (
							<div className="mb-5">
								<div className="col-12 fs-5 fw-bold opacity-50 border-bottom pb-2 mb-3 p-0">
									Download Process File: {dialogFileName}
								</div>
								<div className="d-flex align-items-center">
									<a href={uploadedFile.file} target="_blank" rel="noopener noreferrer">
										<Button
											icon={"pi pi-download"}
											rounded
											className="p-0 px-3 py-1"
											severity="success"
											label="Download Uploaded File"
										/>
									</a>
								</div>
							</div>
					  )}

				{uploadedFile ? (
					<>
						<div className="col-12 fs-5 fw-bold opacity-50 border-bottom pb-2 mb-3 p-0">
							Replace Process File With:{dialogFileName}
						</div>
					</>
				) : (
					<>
						<div className="col-12 fs-5 fw-bold opacity-50 border-bottom pb-2 mb-3 p-0">
							Upload Process File: {dialogFileName}
						</div>
					</>
				)}

				<FileUpload
					name="file"
					url="/upload"
					onSelect={handleFileSelect}
					onError={() => console.log("File upload error")}
					chooseLabel="Choose File"
					accept=".doc, .docx, .xls, .xlsx"
					customUpload
					auto
				/>
			</div>
		</Dialog>
	);
}
